"use strict";
// Wrapper for handling UrlParametes cleanly
//
// Default is to let js do it with URLSearchParams if available
// but contains fallback code if run in setup with out it.
Object.defineProperty(exports, "__esModule", { value: true });
var UrlParameterHelper = /** @class */ (function () {
    function UrlParameterHelper(urlParamsString) {
        if (typeof URLSearchParams === 'function') {
            this.usesUrlSearchParams = true;
            this.urlParams = new URLSearchParams(urlParamsString);
        }
        else {
            // Fall back for when URLSearchParams not available.
            this.usesUrlSearchParams = false;
            var s = urlParamsString;
            if (s[0] === '?') {
                s = s.substring(1);
            }
            var split = s.split('&');
            this.urlParams = new Map();
            for (var _i = 0, split_1 = split; _i < split_1.length; _i++) {
                var element = split_1[_i];
                var kv = element.split('=');
                this.urlParams.set(kv[0], kv.length > 1 ? decodeURIComponent(kv[1]) : '');
            }
        }
    }
    UrlParameterHelper.getInstance = function () {
        if (!UrlParameterHelper.instance) {
            if ((typeof window !== 'undefined') && window.location) {
                UrlParameterHelper.instance = new UrlParameterHelper(window.location.search);
            }
            else if ((typeof document !== 'undefined') && document.location) {
                UrlParameterHelper.instance = new UrlParameterHelper(document.location.search);
            }
            else {
                return new UrlParameterHelper('');
            }
        }
        return UrlParameterHelper.instance;
    };
    UrlParameterHelper.prototype.get = function (name) {
        return this.urlParams.get(name);
    };
    UrlParameterHelper.prototype.delete = function (name) {
        this.urlParams.delete(name);
    };
    UrlParameterHelper.prototype.toString = function () {
        if (this.usesUrlSearchParams) {
            return this.urlParams.toString();
        }
        else {
            // Fall back for when URLSearchParams not available.
            var build_1 = [];
            try {
                var view = (this.urlParams);
                view.forEach(function (v, k) {
                    build_1.push(k + "=" + encodeURIComponent(v));
                });
            }
            catch (e) {
                console.log('Exception processing parameters', e);
            }
            return build_1.join('&');
        }
    };
    return UrlParameterHelper;
}());
exports.default = UrlParameterHelper;
//# sourceMappingURL=UrlParameterHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/UrlParameterHelper.js
// module id = 583
// module chunks = 8